import utils from '@/_modules/utils';
import {gsap, Quart} from 'gsap/all';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

class _eventMv {
  //constructor() {}

  once() {
    this.adjust = 0;
    this.preWidth = 0;
    this.sizeH = {
      sp: 500,
      pc: 800
    };

    this.el = document.getElementById('p-event__mv');
    this.btnScroll = document.getElementById('c-scroll');
    this.btnScroll.addEventListener('click', this.goNext.bind(this));
    
    this.resize();
  }

  init() {

  }
  
  start() {
    // MVオープニング
    gNGF.rootHTML.classList.add('is-eventMv--start');
  }

  goNext() {
    const offset = utils.getOffsetTop(document.getElementById('p-event__list'));

    gsap.to(window, {
      duration: 0.7,
      scrollTo: {
        y: offset.top - this.adjust,
        autoKill: false,
      },
      ease: Quart.easeOut
    });
  }

  resize() {
    const issp = utils.getMatchMedia();
    const winW = window.innerWidth;
    const winH = window.innerHeight;
    if (issp && this.preWidth === winW) return;

    let mvH = winH;
    if (issp) {
      // sp
      if (winH > this.sizeH.sp) mvH = this.sizeH.sp;
      this.adjust = (100 / 750) * window.innerWidth;
    } else {
      // pc
      if (winH > this.sizeH.pc) mvH = this.sizeH.pc;
      this.adjust = 140;
    }

    //this.el.style.height = mvH + 'px';
    this.el.style.width = winW + 'px';
    this.preWidth = winW;
  }
}

const eventMv = new _eventMv();

export default eventMv;